
import { Col, Row, Skeleton } from 'antd';
import { Link } from 'react-router-dom';

import Announcement from 'components/modules/Announcement';
import Title from 'components/modules/Title';
import { useMenuInfo } from 'constants/CustomHooks/useMenuInfo';

import 'styles/pages/home.scss';
import React from 'react';

const Top = () => {
    const meneInfo = useMenuInfo(true);
    return (
        <>
            <Title text='トップ' />

            <Announcement />

            <TileContainer loading={meneInfo.isLoading}>
                {meneInfo.items.map(item => (
                    <Tile
                        description={item.description}
                        icon={item.iconOfTile}
                        isOpenNewTab={item.isOpenNewTab}
                        key={item.url}
                        title={item.title}
                        to={item.url}
                        // すでに表示するもののみ filter 済みなので true
                        visible={true}
                    />
                ))}
            </TileContainer>
        </>
    );
};

export default Top;


type TitleProps = {
    description: string | JSX.Element;
    icon: JSX.Element;
    isOpenNewTab?: boolean;
    title: string | JSX.Element;
    to: string;
    visible: boolean;
};

/**
 * 各画面へのリンクであるタイルコンポーネント
 */
const Tile: React.FC<TitleProps> = ({
    description,
    icon,
    isOpenNewTab = false,
    title,
    to,
    visible,
}) => {
    if (!visible) return null;

    const Component = isOpenNewTab ? (props: any) => <a {...props} /> : Link;
    const openNewTabProps = isOpenNewTab ?
        { href: to, rel: 'noopener noreferrer', target: '_blank' } :
        { to };

    return (
        <Col span={8}>
            <Component
                {...openNewTabProps}
            >
                <div className='home-grid-cell'>
                    <div className='home-gird-icon'>
                        {icon}
                    </div>
                    <div className='home-grid-title'>{title}</div>
                    <div className='home-grid-description'>{description}</div>
                </div>
            </Component>
        </Col>
    );
};

const TileSkelton = [...Array(8)].map((_, index) => (
    <Tile
        description={<Skeleton active paragraph={{ rows: 1, width: '70%' }} title={false} />}
        icon={<Skeleton.Image />}
        key={index}
        title={<Skeleton active paragraph={false} title={{ width: '40%' }} />}
        to='/'
        visible={true}
    />
));

/**
 * タイルコンポーネントを子に持つコンテナとなるコンポーネント
 */
const TileContainer: React.FC<{ children: React.ReactNode, loading: boolean }> = ({ children, loading }) => {
    return (
        <div className='home-grid'>
            <Row align='middle' gutter={[12, 12]} justify='start'>
                {loading ? TileSkelton : children}
            </Row>
        </div>
    );
};